export default "__VITE_ASSET__Ddpo_T3K__"